"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const FilterStateKeysEnum_1 = __importDefault(require("@react/web/Listing/Filter/FilterStateKeysEnum"));
const carIcon = require('@assets/icon/how-it-works-car.svg');
const FixtermListingBannerView = ({ filterFormData, handleResetFilterClick, handleFilterChange, }) => {
    const filterFixtermOffersWithContractLengthUpToYear = (event) => {
        handleResetFilterClick(event);
        const selectedItems = filterFormData.contractLength.filter((item) => Number(item.value) <= 12);
        handleFilterChange(selectedItems, FilterStateKeysEnum_1.default.contractLength);
    };
    return react_1.default.createElement("div", { className: "subscription-fixterm-listing-banner" },
        react_1.default.createElement("div", { className: "image" },
            react_1.default.createElement("img", { src: carIcon, width: "100", height: "80", alt: "Auto na tak dlouho jak pot\u0159ebujete" })),
        react_1.default.createElement("div", { className: "content" },
            react_1.default.createElement("h2", { className: "title" }, "Auta na p\u00E1r m\u011Bs\u00EDc\u016F."),
            react_1.default.createElement("div", null,
                "Hled\u00E1te auto za skv\u011Blou cenu jen na n\u011Bkolik m\u011Bs\u00EDc\u016F? Vyberte si z na\u0161\u00ED \u0161irok\u00E9 nab\u00EDdky.\u00A0",
                react_1.default.createElement("a", { href: "#", onClick: (event) => filterFixtermOffersWithContractLengthUpToYear(event) }, "Zobrazit\u00A0auta\u00A0do\u00A012\u00A0m\u011Bs\u00EDc\u016F"))));
};
exports.default = FixtermListingBannerView;
